import MuiIconButton from '@zenbusiness/zui/IconButton';
import MuiMenu from '@zenbusiness/zui/Menu';
import { styled, superstyled } from '@zenbusiness/zui/styles';

export const Button = superstyled({
  tag: MuiIconButton,
  propsNeeded: ['open'],
  styles: ({ open, theme }) => ({
    // Mobile
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,

    '&:hover': {
      background: theme.palette.primary.main.darker
    },

    [theme.breakpoints.down('md')]: {
      ...(open && {
        background: theme.palette.primary.main.light
      })
    },

    [theme.breakpoints.up('md')]: {
      ...(!open && {
        background: theme.palette.background.grey.dark,
        color: theme.palette.text.primary,

        '&:hover': {
          background: theme.palette.background.grey.darker
        }
      })
    }

  })
});

export const Menu = styled(MuiMenu)(({ theme }) => ({
  '& li > *': {
    flexGrow: 1,
    fontSize: '1.25rem',
    lineHeight: '1.75rem',
    maxWidth: '100%',
    padding: '0 1.5rem',

    [theme.breakpoints.up('lg')]: {
      fontSize: '1.375rem'
    }
  },

  '& .MuiListItem-root .profile-info': {
    [theme.breakpoints.up('lg')]: {
      paddingBlock: '0.25rem'
    }
  },

  '& .MuiPaper-root': {
    borderRadius: '1rem',
    boxShadow: '0 0.25rem 1rem 0.125rem rgba(0, 0, 0, 0.12)',
    marginBlockStart: '0.25rem',
    width: 'calc(100% - 2rem)'
  },
  '& .MuiList-root': {
    paddingBlock: '1rem'
  },
  '& .MuiMenu-paper': {
    maxHeight: 'calc(100vh - 4rem)'
  },
  [theme.breakpoints.up('sm')]: {
    '& .MuiPaper-root': {
      maxWidth: '22rem'
    }
  },
  [theme.breakpoints.up('lg')]: {
    '& .MuiPaper-root': {
      maxWidth: '30rem'
    }
  }
}));
